import { Epic, ofType } from "redux-observable";
import { EmissionActions } from "../actions";
import { RootState } from "../../reducers";
import { Observable } from "rxjs";
import { SAVE_EMISSION, START_EMISSION } from "../constants";
import { switchMap } from "rxjs/operators";
import { EmissionRepository } from "../../../repositories/emission-repository";
import { SaveEmission, StartEmission } from "../actions/default";

export const startEmissionEpic: Epic<
    EmissionActions,
    EmissionActions,
    RootState
> = (action$: Observable<EmissionActions>) =>
    action$.pipe(
        ofType(START_EMISSION),
        switchMap((action) =>
            EmissionRepository.StartEmission(action as StartEmission)
        )
    );

export const saveEmissionEpic: Epic<
    EmissionActions,
    EmissionActions,
    RootState
> = (action$: Observable<EmissionActions>, state$) =>
    action$.pipe(
        ofType(SAVE_EMISSION),
        switchMap((action) => {
            const {
                quotation: { primeSelected, initialMonth, calculated },
                customer: {
                    contact: { email, phone },
                    business: { ruc },
                    naturalName,
                    naturalLastName,
                    naturalMotherLastName,
                    isNaturalPerson,
                },
                payroll_file: { fileName },
                emission: {
                    startIssuance: {
                        consultQuotation,
                        paymentRequestCode,
                        requestNumber,
                    },
                    numberQuotes,
                },
                page: {
                    channels: { distributionCode },
                },
            } = state$.value;
            action.payload = {
                consultQuotation,
                primeSelected,
                calculated,
                userEmail: email,
                fileName,
                ruc,
                phone,
                initialMonth,
                naturalName,
                naturalLastName,
                naturalMotherLastName,
                isNaturalPerson,
                paymentRequestCode,
                requestNumber,
                quoteId: numberQuotes,
                distributionCode,
            };
            return EmissionRepository.SaveEmission(
                action as SaveEmission,
                state$.value
            );
        })
    );
